import { useState, useEffect, useCallback } from "react";
import { AnimatePresence, motion } from "framer-motion";

// A cinematic mix of Surrey scenery photos and moving countryside video
const SLIDES = [
  { type: "video", src: "/videos/gatwick-family-720.mp4", poster: "/videos/gatwick-family-poster.jpg" },
  { type: "image", src: "/images/hero/clocktower-car.jpg", alt: "A Clocktower Cars executive Mercedes being driven through the Surrey countryside" },
  { type: "image", src: "/images/hero/surrey-hills.jpg", alt: "Aerial view of the Surrey Hills countryside at sunrise" },
  { type: "image", src: "/images/hero/surrey-hills-2.jpg", alt: "A Surrey village and winding country lane at golden hour" },
];

export const HeroBackground = () => {
  const [index, setIndex] = useState(0);
  const advance = useCallback(() => setIndex((p) => (p + 1) % SLIDES.length), []);

  useEffect(() => {
    // images hold for 7s; video is a safety cap in case onEnded never fires
    const ms = SLIDES[index].type === "image" ? 7000 : 16000;
    const t = setTimeout(advance, ms);
    return () => clearTimeout(t);
  }, [index, advance]);

  const slide = SLIDES[index];

  return (
    <div className="absolute inset-0 overflow-hidden" data-testid="hero-bg" aria-hidden="true">
      <AnimatePresence>
        <motion.div
          key={index}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 1.8, ease: "easeInOut" }}
          className="absolute inset-0"
        >
          {slide.type === "image" ? (
            <img
              src={slide.src}
              alt={slide.alt}
              className="h-full w-full object-cover animate-kenburns"
              draggable="false"
            />
          ) : (
            <video
              className="h-full w-full object-cover"
              src={slide.src}
              poster={slide.poster}
              autoPlay
              muted
              playsInline
              preload="metadata"
              onEnded={advance}
            />
          )}
        </motion.div>
      </AnimatePresence>
    </div>
  );
};
